import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getClaimCommodityCodeListEffect } from '../Claims/LossAndDamage/LossAndDamageClaimsEffects';
import { setLDClaimCommodityCodeList } from '../common/CommonActions';

const useClaimsCommodityCodeList = () => {
  const [list, setList] = useState(undefined);
  const { LDCommodityCode } = useSelector((state) => state.common);
  const dispatch = useDispatch();

  // biome-ignore lint/correctness/useExhaustiveDependencies: fix this
  useEffect(() => {
    if (LDCommodityCode.success) {
      setList(LDCommodityCode.data);
    } else {
      getList();
    }
  }, [LDCommodityCode]);

  const getList = async () => {
    try {
      dispatch(setLDClaimCommodityCodeList({ data: [], success: true }));
      const { data } = await getClaimCommodityCodeListEffect();
      setList(data);
      dispatch(setLDClaimCommodityCodeList({ data, success: true }));
    } catch {
      setList([]);
    }
  };

  return list;
};

export default useClaimsCommodityCodeList;
